//-------------------------------------------------------------------------------------------------- Imports
import { CSSProperties } from "react";

//-------------------------------------------------------------------------------------------------- Interfaces
interface TextSpliterProps {
    text: string;
    style?: CSSProperties
};

//-------------------------------------------------------------------------------------------------- Component
const TextSplitter = (props: TextSpliterProps) => {
    const {text, style} = props;
    const mapper = text.split("\n");

    return(
        <>
            {(mapper.map((str, index) => (
                <p key={index} style={style}>{str}</p>
            )))}
        </>
    );
};

//-------------------------------------------------------------------------------------------------- Exports 
export default TextSplitter;
